// Upload progress lives OUTSIDE React state on purpose. axios fires onUploadProgress many times a second per file; putting
// that in the Studio queue state re-rendered the whole (very large) Studio on every tick. Here a tick only wakes the progress
// bar of the one card that shows it, and the reporter throttles to ~4 updates a second. The queue state is written once, when
// the upload ends.
import { useSyncExternalStore } from 'react';

const values = new Map();
const subs = new Map();

function emit(id) { (subs.get(id) || new Set()).forEach(fn => fn()); }
export function setUploadProgress(id, pct) {
  if (values.get(id) === pct) return;
  values.set(id, pct);
  emit(id);
}
export function clearUploadProgress(id) { values.delete(id); emit(id); }
export const getUploadProgress = (id) => values.get(id) || 0;
function subscribe(id, fn) {
  if (!subs.has(id)) subs.set(id, new Set());
  subs.get(id).add(fn);
  return () => { const s = subs.get(id); if (s) { s.delete(fn); if (!s.size) subs.delete(id); } };
}
export function useUploadProgress(id) {
  return useSyncExternalStore((fn) => subscribe(id, fn), () => values.get(id) || 0);
}

// axios onUploadProgress handler for file `id`: whole-percent steps, at most one update per `intervalMs` (the last tick
// before the end always goes through). `now` is injectable for tests.
export function makeProgressReporter(id, intervalMs = 250, now = () => Date.now()) {
  let last = 0;
  return (ev) => {
    if (!ev || !ev.total) return;
    const pct = Math.round((ev.loaded / ev.total) * 100);
    const t = now();
    if (pct < 100 && t - last < intervalMs) return;
    last = t;
    setUploadProgress(id, pct);
  };
}
